import "./pages/instances/sales/promostores/promoStoreSaveAuth";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
} from "react-router-dom";
import {
  NotificationProvider,
  getSocket,
} from "./components/NotificationContext";
import { Toaster } from "react-hot-toast";

import Home from "./pages/essentials/MainDashboard";
import CreatePost from "./pages/instances/InstanceCreate";
import InstanceGetStartedWizard from "./pages/instances/InstanceGetStartedWizard";
import InstancePaymentFailed from "./pages/instances/InstancePaymentFailed";
import ProductSearch from "./pages/product-search/ProductSearch";

// Connect
import InstanceFeedAndActivity from "./pages/instances/connect/feed-and-activity/InstanceFeedAndActivity";
import InstanceSuppliers from "./pages/instances/connect/suppliers/InstanceSuppliers";
import InstanceProducts from "./pages/instances/connect/products/InstanceProducts";

// Sales
import InstanceSalesDashboard from "./pages/instances/sales/dashboard/InstanceDashboard";
import InstanceOrders from "./pages/instances/sales/orders/InstanceOrders";
import InstancePipeline from "./pages/instances/sales/pipeline/InstancePipeline";
import InstanceSingleOrderManager from "./pages/instances/sales/orders/orders-single/InstanceOrderSingle";
import InstanceCustomers from "./pages/instances/sales/customers/InstanceCustomers";
import InstancePromoStores from "./pages/instances/sales/promostores/InstancePromoStores";
import PromoStoreMarketplace from "./pages/instances/sales/promostores/PromoStoreMarketplace";
import InstancePromoStoreDetails from "./pages/instances/sales/promostores/InstancePromoStoreDetails";
import InstancePromoStoreProductReport from "./pages/instances/sales/promostores/reports/InstancePromoStoreProductReport";
import InstanceSalesAnalytics from "./pages/instances/sales/analytics/InstanceAnalytics";
import InstanceProspects from "./pages/instances/crm/prospects/InstanceProspects";

// Operations
import InstanceOperationsDashboard from "./pages/instances/operations/dashboard/InstanceDashboard";

// Production
import InstanceProductionDashboard from "./pages/instances/production/dashboard/InstanceDashboard";
import InstanceProductionAnalytics from "./pages/instances/production/analytics/InstanceAnalytics";
import EliteProduction from "./pages/instances/production/production/EliteProduction";

import MachineManagements from "./pages/instances/production/production/MachineManagements";

// Finances
import InstanceFinancesDashboard from "./pages/instances/finance/dashboard/InstanceDashboard";
import InstanceBilling from "./pages/instances/finance/billing/InstanceBilling";
import InstanceInvoicing from "./pages/instances/finance/invoicing/InstanceInvoicing";
import ThirdPartyImport from "./pages/instances/finance/invoicing/ThirdPartyImport"
import InstanceShippingLabels from "./pages/instances/shipping/labels/InstanceShippingLabels";
import InstanceWarehouseBuilder from "./pages/instances/shipping/warehouse/InstanceWarehouseBuilder";

// Reports
import InstanceReportsDashboard from "./pages/instances/reports/dashboard/InstanceDashboard";
import InstanceCommissionsReport from "./pages/instances/reports/commissions/";
import InstanceSalesReport from "./pages/instances/reports/sales/";
import InstanceDocumentReport from "./pages/instances/reports/documents/";
import InstanceProductSoldReport from "./pages/instances/reports/product-sold/";
import InstanceSupplierReport from "./pages/instances/reports/supplier/";
import InstanceSupplierBillPipelineReport from "./pages/instances/reports/supplier-bill-pipeline/";
import InstanceClientInvoicingReport from "./pages/instances/reports/client-invoicing/";
import InstanceWorkInProgressReport from "./pages/instances/reports/work-in-progress/";
import InstanceArAgingReport from "./pages/instances/reports/ar-aging/";

// General Settings
import InstanceUsers from "./pages/instances/settings/users/InstanceUsers";
import InstanceGlobalSettings from "./pages/instances/settings/global-settings/InstanceGlobalSettings";
import InstanceSyncProducts from "./pages/instances/my-website/InstanceSyncProducts";
import Registration from "./pages/profile/Registration";
import PaymentMethods from "./pages/profile/PaymentMethods";
import Login from "./pages/profile/Login";
import ForgotPassword from "./pages/profile/ForgotPassword";
import EmailIcon from "@mui/icons-material/Email";
import ForgotPasswordTokenValid from "./pages/profile/ForgotPasswordTokenValid";
import InvoicesManager from "./pages/invoices/InvoicesManager";
import PageNotFound from "./pages/essentials/PageNotFound";
import PublicCustomerPage from "./pages/customer/PublicCustomerPage";
import Profile from "./pages/profile/Profile";
import ProfileEzeeAI from "./pages/profile/ProfileEzeeAI";
import ChangePassword from "./pages/profile/ProfileChangePassword";
import { AuthContext } from "./helpers/AuthContext";
import { useState, useEffect, Fragment } from "react";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { resolveGeneralLoginView } from "./helpers/generalLoginRouting";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import WelcomeToEliteCore from "./pages/essentials/WelcomeToEliteCore";
import UpdateLog from "./pages/essentials/UpdateLog";
import GeneratedSalesOrder from "./components/GeneratedSalesOrder";
import GeneratedInvoice from "./components/GeneratedInvoice";
import InvoicePaymentResult from "./components/InvoicePaymentResult";
import GeneratedpurchaseOrder from "./components/PurchaseOrder/GeneratedPurchaseOrder";
import PurchaseOrderPrintPreview from "./components/PurchaseOrder/PrintPreview/PurchaseOrderPrintPreview";
import GeneratedProof from "./components/GeneratedProof";
import GeneratedProofs from "./components/GeneratedProofs";
import InstanceAIHub from "./pages/instances/ai/InstanceAIHub";
import PromoShowcasePage from "./pages/instances/dashboard/PromoShowcasePage";
import InstanceManager from "./pages/instances/InstanceManager";
import { DEFAULT_TIME_ZONE, getInstanceTimeZone } from "./utils/timezone";
import CoreNetworkDashboard from "./pages/instances/core-network/CoreNetworkDashboard";
import CoreNetworkWorkRequestList from "./pages/instances/core-network/CoreNetworkWorkRequestList";
import CoreNetworkWorkRequestDetail from "./pages/instances/core-network/CoreNetworkWorkRequestDetail";
import CoreNetworkTalentList from "./pages/instances/core-network/CoreNetworkTalentList";
import CoreNetworkTalentDetail from "./pages/instances/core-network/CoreNetworkTalentDetail";
import CoreNetworkMatchesPage from "./pages/instances/core-network/CoreNetworkMatchesPage";
import CoreNetworkSettings from "./pages/instances/core-network/CoreNetworkSettings";
import { CORE_NETWORK_PERMISSIONS, hasAnyCoreNetworkPermission } from "./helpers/coreNetworkPermissions";
import { getCoreNetworkAccessProfile } from "./services/coreNetwork";
import NetworkPortalDashboard from "./pages/network/NetworkPortalDashboard";
import NetworkPortalAssignmentList from "./pages/network/NetworkPortalAssignmentList";
import NetworkPortalAssignmentDetail from "./pages/network/NetworkPortalAssignmentDetail";
import NetworkPortalOfferList from "./pages/network/NetworkPortalOfferList";
import NetworkPortalOfferDetail from "./pages/network/NetworkPortalOfferDetail";
import TalentLogin from "./pages/talent/TalentLogin";
import TalentForgotPassword from "./pages/talent/TalentForgotPassword";
import TalentChangePassword from "./pages/talent/TalentChangePassword";
import TalentResetPassword from "./pages/talent/TalentResetPassword";
import TalentVerifyAccount from "./pages/talent/TalentVerifyAccount";
import TalentProfile from "./pages/talent/TalentProfile";
import {
  clearNetworkPortalToken,
  getCurrentNetworkPortalMember,
  getNetworkPortalToken,
  logoutNetworkPortalMember,
  NETWORK_PORTAL_AUTH_CHANGED_EVENT,
} from "./services/coreNetworkPortal";
import {
  HEADER_IDENTITY_KIND,
  resolveHeaderIdentity,
} from "./helpers/headerIdentity";
import { normalizeCoreNetworkUiConfig } from "./helpers/coreNetworkUiConfig";

import { withProductionStyles } from "./styles/withProductionStyles";
import { Typography } from "@mui/material";
import GlobalHeaderSearch from "./components/GlobalHeaderSearch/GlobalHeaderSearch";
import GlobalHeaderSearchErrorBoundary from "./components/GlobalHeaderSearch/GlobalHeaderSearchErrorBoundary";
import PageTitleManager from "./components/PageTitleManager";
import GlobalEzeeAssistant from "./components/EzeeAI/GlobalEzeeAssistant";
//import PaymentSuccessModal from "./components/Invoices/InvoiceList/PaymentSuccessModal";

/* HAMBURGER */
import { slide as Menu } from "react-burger-menu";
import Presentations from "./components/Presentations";
import NotificationPanel from "./pages/Header/NotificationPanel";
import "./pages/Header/NotificationPanel.css";

// MUI
/* Header avatar is rendered only after its real image has loaded. */

import DepartmentManagement from "./pages/instances/production/production/DepartmentManagement";

import EliteProductionMaterialsManagement from './pages/instances/production/production/EliteProductionMaterialsManagement';

import EliteProductionDepartmentManagement from "./pages/instances/production/production/EliteProductionDepartmentManagement";
import EliteProductionChargeStrategies from "./pages/instances/production/production/EliteProductionChargeStrategies";

import AppFooter from "./components/AppFooter";

// New component: CommentUpdateBox
const CommentUpdateBox = ({ latestUpdate, count }) => {
  return (
    <div
      className="comment-update-box"
      style={{
        position: "relative",
      }}
    >
      <Typography variant="body2">{latestUpdate}</Typography>
      {count > 0 && (
        <div>
          <div style={{ position: "relative", display: "inline-block" }}>
            {/* Envelope icon */}
            <EmailIcon
              style={{
                fontSize: 28,
                color: "white",
                backgroundColor: "#f44336", // red background
                borderRadius: "50%",
                padding: "4px",
              }}
            />
            {/* Notification bubble overlaid on the envelope */}
            <div
              className="notification-bubble"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                background: "#fef2f2",
                fontWeight: 700,
                borderRadius: "50%",
                transform: "translate(50%, -50%)",
                minWidth: "20px",
                textAlign: "center",
                lineHeight: 1,
              }}
            >
              {count > 99 ? "99+" : count}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

function CoreNetworkRouteGuard({ authState, instanceUniqueId, permissions, requireMatchesEnabled = false, children }) {
  const [accessProfile, setAccessProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    async function loadAccessProfile() {
      if (!authState?.status || !instanceUniqueId) {
        if (active) {
          setAccessProfile(null);
          setLoading(false);
        }
        return;
      }

      setLoading(true);
      try {
        const response = await getCoreNetworkAccessProfile(instanceUniqueId);
        if (active) {
          setAccessProfile(response.accessProfile || null);
        }
      } catch (_error) {
        if (active) {
          setAccessProfile(null);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadAccessProfile();
    return () => {
      active = false;
    };
  }, [authState?.status, instanceUniqueId]);

  const effectiveAuthState = {
    ...authState,
    coreNetworkAccessProfile: accessProfile || authState?.coreNetworkAccessProfile || null,
  };
  const uiConfig = normalizeCoreNetworkUiConfig(
    accessProfile?.uiConfig || authState?.coreNetworkAccessProfile?.uiConfig || null
  );
  const canAccess = hasAnyCoreNetworkPermission(effectiveAuthState, permissions, instanceUniqueId);
  const isRouteAvailable = requireMatchesEnabled ? uiConfig.matchesEnabled !== false : true;

  if (loading) {
    return <Typography>Loading Core Network access...</Typography>;
  }

  return canAccess && isRouteAvailable ? children : <PageNotFound />;
}

const normalizeAppRole = (role) => String(role || "").replace(/[_\s]+/g, "-").trim().toLowerCase();
const REPORT_FINANCE_ROLES = new Set(["administrator", "admin", "finance-rep", "finance", "accounting"]);
const REPORT_DASHBOARD_ROLES = new Set([...REPORT_FINANCE_ROLES, "analytics-rep"]);
const REPORT_SALES_ROLES = new Set([...REPORT_FINANCE_ROLES, "client-rep", "order-rep"]);

function ReportRouteGuard({ authState, instanceUniqueId, report = "finance", children }) {
  const role = normalizeAppRole(authState?.role);
  const selfScopedSalesRole = role === "client-rep" || role === "order-rep";

  if (report === "dashboard" && selfScopedSalesRole) {
    return <Redirect to={`/instance/${instanceUniqueId}/reports/sales-rep`} />;
  }

  const allowed = report === "sales"
    ? REPORT_SALES_ROLES.has(role)
    : report === "dashboard"
      ? REPORT_DASHBOARD_ROLES.has(role)
      : REPORT_FINANCE_ROLES.has(role);

  return allowed ? children : <PageNotFound />;
}

// Preload the actual profile image before showing it. Avoid the temporary
// placeholder/initials flash while basicinfo and the image are still loading.
function HeaderProfileAvatar({ src, onSettled }) {
  const [loadedSrc, setLoadedSrc] = useState(null);
  const isPlaceholder = !src || src === "/elite-core-placeholder-avatar.png";

  useEffect(() => {
    if (isPlaceholder) {
      setLoadedSrc(null);
      onSettled(src);
      return;
    }

    let active = true;
    const image = new Image();
    image.onload = () => {
      if (!active) return;
      setLoadedSrc(src);
      onSettled(src);
    };
    image.onerror = () => {
      if (!active) return;
      setLoadedSrc(null);
      onSettled(src);
    };
    image.src = src;

    return () => {
      active = false;
      image.onload = null;
      image.onerror = null;
    };
  }, [src, isPlaceholder, onSettled]);

  return (
    <span className="ec-profile-avatar-slot" aria-hidden="true">
      {!isPlaceholder && loadedSrc === src && (
        <img
          className="ec-profile-avatar-image"
          src={src}
          alt=""
          onError={() => setLoadedSrc((current) => (current === src ? null : current))}
        />
      )}
    </span>
  );
}

function App() {
  const [authState, setAuthState] = useState({
    email: "",
    first_name: "",
    role: "unknown",
    id: 0,
    status: false,
  });
  var cookieEnabled = navigator.cookieEnabled;
  const socket = getSocket();
  const [avatarUrl, setAvatarUrl] = useState("/elite-core-placeholder-avatar.png");
  const [avatarFetchState, setAvatarFetchState] = useState({ userId: null, settled: false });
  const [avatarImageSettledUrl, setAvatarImageSettledUrl] = useState(null);
  // Only a fresh Home load gets an entrance. If the navbar was already
  // visible on Login or another page, don't hide and replay its logo later.
  const [homeHeaderEntrance, setHomeHeaderEntrance] = useState(
    () => window.location.pathname === "/" ? "pending" : "complete"
  );
  const [globalHeaderSearchResetKey, setGlobalHeaderSearchResetKey] = useState(0);
  const [talentMember, setTalentMember] = useState(null);
  const [talentAuthLoading, setTalentAuthLoading] = useState(() => Boolean(getNetworkPortalToken()));
  const [talentAuthError, setTalentAuthError] = useState("");
  const [talentAuthRefreshKey, setTalentAuthRefreshKey] = useState(0);

  // same logic you use in Profile, but local to App.js
  const normalizeAvatarUrl = (imgSrc) => {
    if (typeof imgSrc === "string" && imgSrc.startsWith("uploads")) {
      return `${process.env.REACT_APP_NODEJS_SERVER_URL}/${imgSrc}`;
    }
    return imgSrc;
  };

  const [overrideRole, setOverrideRole] = useState("");
  const [activeInstance, setActiveInstance] = useState(null);
  const [activeInstanceTimezone, setActiveInstanceTimezone] = useState(DEFAULT_TIME_ZONE);
  const [hasInitialized, setHasInitialized] = useState(false); // ✅ New flag

  useEffect(() => {
    if (cookieEnabled && !hasInitialized) {

      const accessToken = localStorage.getItem("accessToken");

      if (!accessToken) {
        setAuthState((prev) => ({ ...prev, status: false }));
        setHasInitialized(true);
        return;
      }

      axios
        .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/auth`, {
          headers: {
            accessToken,
          },
        })
        .then((response) => {
          if (response.data.error) {
            setAuthState((prev) => ({ ...prev, status: false }));
            setHasInitialized(true);
          } else {
            setAuthState({
              email: response.data.email,
              first_name: response.data.first_name,
              role: overrideRole || response.data.role,
              id: response.data.id,
              instanceId: response.data.instanceID,
              status: true,
            });

            // ✅ Only set override once based on original response
            if (!overrideRole) {
              setOverrideRole(response.data.role);
            }

            setHasInitialized(true);
          }
        }).catch((error) => {
          if (error?.response?.status === 401) {
            localStorage.removeItem("accessToken");
            setAuthState((prev) => ({ ...prev, status: false }));
            setHasInitialized(true);
            return;
          }

          console.error("Auth check failed:", error);
          setAuthState((prev) => ({ ...prev, status: false }));
          setHasInitialized(true);
        });
    }
  }, [cookieEnabled, hasInitialized, overrideRole]);

  useEffect(() => {
    const handleTalentAuthChanged = () => {
      setTalentAuthRefreshKey((current) => current + 1);
    };

    window.addEventListener(NETWORK_PORTAL_AUTH_CHANGED_EVENT, handleTalentAuthChanged);
    return () => {
      window.removeEventListener(NETWORK_PORTAL_AUTH_CHANGED_EVENT, handleTalentAuthChanged);
    };
  }, []);

  useEffect(() => {
    let active = true;

    async function hydrateTalentSession() {
      const token = getNetworkPortalToken();

      if (!token) {
        if (active) {
          setTalentMember(null);
          setTalentAuthError("");
          setTalentAuthLoading(false);
        }
        return;
      }

      if (active) {
        setTalentAuthLoading(true);
        setTalentAuthError("");
      }

      try {
        const response = await getCurrentNetworkPortalMember();
        if (active) {
          setTalentMember(response.member || null);
        }
      } catch (error) {
        clearNetworkPortalToken();
        if (active) {
          setTalentMember(null);
          setTalentAuthError(
            error?.response?.data?.message ||
              error.message ||
              "Unable to load your Talent portal session."
          );
        }
      } finally {
        if (active) {
          setTalentAuthLoading(false);
        }
      }
    }

    hydrateTalentSession();
    return () => {
      active = false;
    };
  }, [talentAuthRefreshKey]);

  useEffect(() => {
    if (!authState.status || !authState.id) return;

    let active = true;
    const userId = authState.id;
    setAvatarFetchState({ userId, settled: false });

    axios
      .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/auth/basicinfo/${userId}`)
      .then((res) => {
        if (!active) return;
        let pic = res.data?.profilePicture;
        let url = "/elite-core-placeholder-avatar.png";

        if (pic) {
          if (typeof pic === "string") {
            try { pic = JSON.parse(pic); } catch {}
          }
          if (Array.isArray(pic) && pic.length > 0) {
            const selected = pic.find((p) => p.selected) || pic[0];
            url = selected.url || url;
          } else if (typeof pic === "string") {
            url = pic;
          }
        }
        setAvatarUrl(normalizeAvatarUrl(url));
        setAvatarFetchState({ userId, settled: true });
      })
      .catch(() => {
        if (!active) return;
        // A missing profile image should not block the navbar or show a placeholder.
        setAvatarUrl("/elite-core-placeholder-avatar.png");
        setAvatarFetchState({ userId, settled: true });
      });

    return () => { active = false; };
  }, [authState.status, authState.id]);

  useEffect(() => {
    const match = window.location.pathname.match(/\/instance\/([^/]+)/);
    const instanceUniqueId = match ? match[1] : "";

    if (!instanceUniqueId) {
      setActiveInstance(null);
      setActiveInstanceTimezone(DEFAULT_TIME_ZONE);
      return;
    }

    let cancelled = false;

    axios
      .get(`${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/byinstanceUniqueId/${instanceUniqueId}`)
      .then((response) => {
        if (cancelled) return;
        const instance = response?.data || null;
        setActiveInstance(instance);
        setActiveInstanceTimezone(getInstanceTimeZone(instance));
      })
      .catch(() => {
        if (cancelled) return;
        setActiveInstance(null);
        setActiveInstanceTimezone(DEFAULT_TIME_ZONE);
      });

    return () => {
      cancelled = true;
    };
  }, [window.location.pathname]);
  

  const logout = () => {
    localStorage.removeItem("accessToken");
    setAuthState({
      email: "",
      first_name: "",
      role: "unknown",
      id: 0,
      instanceId: 0,
      status: false,
    });
    window.location.reload();
  };

  const logoutTalent = async () => {
    try {
      await logoutNetworkPortalMember();
    } catch (_error) {
      // Continue with local cleanup and redirect.
    }

    setTalentMember(null);
    setTalentAuthError("");
    setTalentAuthLoading(false);
    clearNetworkPortalToken();
    window.location.replace("/talent/login");
  };

  const pathname = window.location.pathname;

  const hideNavbarRoutes = [
    "/generated-sales-order",
    "/generated-invoice",
    "/invoice-payment-result",
    "/generated-estimate",
    "/generated-purchase-order",
    "/generated-proof",
    "/presentations",
    "/network",
  ];


  const shouldShowNavbar =
    !hideNavbarRoutes.some((route) => pathname.startsWith(route)) &&
    !pathname.split("/").includes("presentations");

  // Public authentication pages keep their header, but not the app footer.
  const shouldShowFooter = shouldShowNavbar &&
    pathname !== "/login" &&
    pathname !== "/forgot-password" &&
    !pathname.startsWith("/forgot-password/");

  const headerIdentity = resolveHeaderIdentity({
    pathname,
    authState,
    isUserLoading: cookieEnabled && !hasInitialized,
    userAvatarUrl: avatarUrl,
    onUserLogout: logout,
    talentAuth: {
      member: talentMember,
      isLoading: talentAuthLoading,
      error: talentAuthError,
    },
    onTalentLogout: logoutTalent,
  });

  // Do not treat the initial LOADING identity as ready. The image may take
  // longer than the account API; both must resolve before the single entrance.
  const homeHeaderDataReady = headerIdentity.kind !== HEADER_IDENTITY_KIND.LOADING &&
    (headerIdentity.kind !== HEADER_IDENTITY_KIND.USER ||
      (avatarFetchState.userId === authState.id &&
        avatarFetchState.settled &&
        avatarImageSettledUrl === headerIdentity.avatarUrl));
  const isHomePath = pathname === "/";

  useEffect(() => {
    if (!isHomePath || homeHeaderEntrance !== "pending" || !homeHeaderDataReady) return;
    // A reduced-motion preference skips the reveal without hiding anything.
    const skipAnimation = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setHomeHeaderEntrance(skipAnimation ? "complete" : "revealing");
  }, [isHomePath, homeHeaderEntrance, homeHeaderDataReady]);

  const homeHeaderEntranceClass = isHomePath && homeHeaderEntrance !== "complete"
    ? ` ec-home-identity-${homeHeaderEntrance}`
    : "";

  const hasAnySessionToken = Boolean(
    localStorage.getItem("accessToken") || getNetworkPortalToken()
  );
  const appShellClassName =
    headerIdentity.kind === HEADER_IDENTITY_KIND.GUEST && !hasAnySessionToken
      ? "App user-not-logged-in"
      : "App user-logged-in";
  const shouldShowHeaderSearch =
    headerIdentity.kind === HEADER_IDENTITY_KIND.USER &&
    Boolean(localStorage.getItem("accessToken"));

  return (
    <Fragment>
      <NotificationProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 10000,
          }}
        />
        {!window.location.pathname.includes("/instance/embed") ? (
          <div className={appShellClassName}>
            <AuthContext.Provider
              value={{
                authState,
                setAuthState,
                overrideRole,
                setOverrideRole,
                activeInstance,
                setActiveInstance,
                activeInstanceTimezone,
                setActiveInstanceTimezone,
                talentAuth: {
                  member: talentMember,
                  isAuthenticated: Boolean(talentMember),
                  isLoading: talentAuthLoading,
                  error: talentAuthError,
                  setError: setTalentAuthError,
                  logout: logoutTalent,
                },
              }}
            >
              <Router>
                <PageTitleManager />
                {shouldShowNavbar && (
                  <div className={`navbar${homeHeaderEntranceClass}`}>
                    <div className="logo" onAnimationEnd={(event) => {
                      if (event.target === event.currentTarget &&
                          event.animationName === "ec-home-identity-in" &&
                          homeHeaderEntrance === "revealing") {
                        setHomeHeaderEntrance("complete");
                      }
                    }}>
                      <a href="/" replace>
                        <img src="/logo.png" alt="Elite Core Logo" />
                      </a>
                    </div>
                    {shouldShowHeaderSearch ? (
                      <div className="navbar__search">
                        <GlobalHeaderSearchErrorBoundary
                          resetKey={globalHeaderSearchResetKey}
                          onRetry={() =>
                            setGlobalHeaderSearchResetKey((current) => current + 1)
                          }
                          onClear={() =>
                            setGlobalHeaderSearchResetKey((current) => current + 1)
                          }
                        >
                          <GlobalHeaderSearch key={globalHeaderSearchResetKey} />
                        </GlobalHeaderSearchErrorBoundary>
                      </div>
                    ) : null}
                    {shouldShowHeaderSearch ? (
                      <GlobalEzeeAssistant authState={authState} />
                    ) : null}
                      {headerIdentity.kind === HEADER_IDENTITY_KIND.LOADING ? (
                        <div className="links links--loading" role="status" aria-label="Loading account" />
                      ) : headerIdentity.kind === HEADER_IDENTITY_KIND.GUEST ? (
                        <>
                          <div className="links">
                            <Link to="/login"> Login</Link>
                            {/*<Link to="/registration" className="create-account-cta">
                            {" "}
                            Join today
                          </Link>*/}
                          </div>
                          {/* MOBILE NAVIGATION */}
                          {
                            <Menu className={"ec-mobile-menu"} isOpen={false}>
                              <Link to="/login"> Login</Link>
                              {/*<Link to="/registration" className="create-account-cta">
                              {" "}
                              Join today
                            </Link>*/}
                          </Menu>
                        }
                      </>
                    ) : (
                      <>
                        {/* DESKTOP NAVIGATION */}
                        {
                          <div className="links">
                            {/* <CommentUpdateBox latestUpdate="" count={12} /> */}
                            {headerIdentity.kind === HEADER_IDENTITY_KIND.USER ? <NotificationPanel /> : null}
                            <div className="dropdown ec-profile-dropdown">
                              <button
                                type="button"
                                className="dropbtn user-drop"
                                aria-haspopup="true"
                                aria-label={`Account menu for ${headerIdentity.displayName}`}
                              >
                                <HeaderProfileAvatar src={headerIdentity.avatarUrl} onSettled={setAvatarImageSettledUrl} />
                                <span className="ec-profile-trigger-name">{headerIdentity.displayName}</span>
                                <KeyboardArrowDownIcon className="ec-profile-trigger-chevron" />
                              </button>
                              <div className="dropdown-content ec-profile-dropdown-menu">
                                {headerIdentity.menuItems.map((item) => (
                                  <Link
                                    key={item.to}
                                    to={item.to}
                                    className={`${item.className || "adminButton"} ec-profile-item`}
                                  >
                                    <span className="ec-profile-menu-icon" aria-hidden="true">
                                      {item.to.includes("profile") ? <PersonOutlineIcon /> : <DashboardOutlinedIcon />}
                                    </span>
                                    <span>{item.label}</span>
                                  </Link>
                                ))}
                                <div className="ec-profile-menu-divider" role="separator" />
                                <button type="button" className="logout ec-profile-item ec-profile-logout" onClick={headerIdentity.onLogout}>
                                  <span className="ec-profile-menu-icon" aria-hidden="true"><LogoutOutlinedIcon /></span>
                                  <span>Logout</span>
                                </button>
                              </div>
                            </div>
                          </div>
                          }
                          {/* MOBILE NAVIGATION */}
                          {
                            <Menu className={"ec-mobile-menu"} isOpen={false}>
                              {headerIdentity.kind === HEADER_IDENTITY_KIND.USER ? (
                                <>
                                  <h2>Manage cores</h2>
                                  <Link to="/"> My cores</Link>
                                  <h2>Manage profile</h2>
                                </>
                              ) : (
                                <h2>Talent Portal</h2>
                              )}
                              {headerIdentity.menuItems.map((item) => (
                                <Link key={item.to} to={item.to}>
                                  {item.label}
                                </Link>
                              ))}
                              {headerIdentity.kind === HEADER_IDENTITY_KIND.USER ? (
                                <CommentUpdateBox latestUpdate="" count={12} />
                              ) : null}
                              <button type="button" className="logout" onClick={headerIdentity.onLogout}>
                                {" "}
                                Logout
                              </button>
                            </Menu>
                          }
                        </>
                      )}
                    </div>
                  )}
                <Switch>
                  {/* Public product update history - accessible without signing in. */}
                  <Route path="/update-log" exact component={UpdateLog} />
                  <Route path="/activity-log" exact render={() => <Redirect to="/update-log" />} />
                  {/* Routes below */}
                  <Route path="/talent/login" exact component={TalentLogin} />
                  <Route path="/talent/forgot-password" exact component={TalentForgotPassword} />
                  <Route path="/talent/reset-password" exact component={TalentResetPassword} />
                  <Route path="/talent/change-password" exact component={TalentChangePassword} />
                  <Route path="/talent/verify-account" exact component={TalentVerifyAccount} />
                  <Route path="/talent/profile" exact component={TalentProfile} />
                  <Route path="/talent" exact component={NetworkPortalDashboard} />
                  <Route path="/talent/assignments" exact component={NetworkPortalAssignmentList} />
                  <Route path="/talent/assignments/:id" exact component={NetworkPortalAssignmentDetail} />
                  <Route path="/talent/offers" exact component={NetworkPortalOfferList} />
                  <Route path="/talent/offers/:id" exact component={NetworkPortalOfferDetail} />
                  <Route path="/network" exact component={NetworkPortalDashboard} />
                  <Route path="/network/assignments" exact component={NetworkPortalAssignmentList} />
                  <Route path="/network/assignments/:id" exact component={NetworkPortalAssignmentDetail} />
                  <Route path="/network/offers" exact component={NetworkPortalOfferList} />
                  <Route path="/network/offers/:id" exact component={NetworkPortalOfferDetail} />
                  <Route
                    path="/product-search"
                    exact
                    component={ProductSearch}
                  />
                  {/* Connect */}
                  <Route
                    path="/instance/:instanceUniqueId/connect"
                    exact
                    component={InstanceFeedAndActivity}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/connect/feed-and-activity"
                    exact
                    component={InstanceFeedAndActivity}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/connect/suppliers"
                    exact
                    component={InstanceSuppliers}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/connect/products"
                    exact
                    component={InstanceProducts}
                  />
                  {/* Sales */}
                  <Route
                    path="/instance/:instanceUniqueId/sales"
                    exact
                    component={InstanceSalesDashboard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/dashboard"
                    exact
                    component={InstanceSalesDashboard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/orders"
                    exact
                    component={InstanceOrders}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/pipeline"
                    exact
                    component={InstancePipeline}
                  />
                  <Route
                    path="/instance/elite-promo-marketing/presentations/:id"
                    component={Presentations}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/orders/:orderId/:tabtype/:tabId?"
                    exact
                    component={InstanceSingleOrderManager}
                  />
                  <Route
                    path={["/generated-sales-order/:id", "/generated-estimate/:id"]}
                    exact
                    component={GeneratedSalesOrder}
                  />
                  <Route
                    path="/invoice-payment-result/:invoiceId"
                    exact
                    component={InvoicePaymentResult}
                  />
                  <Route
                    path="/generated-invoice/:id"
                    exact
                    component={GeneratedInvoice}
                  />
                  <Route
                    path="/generated-purchase-order/:id"
                    exact
                    component={GeneratedpurchaseOrder}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/purchase-orders/:poId/print/:docType"
                    exact
                    component={PurchaseOrderPrintPreview}
                  />
                  <Route
                    path="/generated-proof/:poId/:proofId"
                    exact
                    component={GeneratedProof}
                  />
                  <Route
                    path="/generated-proof/:proofId"
                    exact
                    component={GeneratedProof}
                  />
                  <Route path="/generated-proofs/:poId" exact component={GeneratedProofs} />
                  <Route path="/generated-proofs/order/:orderId" exact component={GeneratedProofs} />

                  <Route
                    path="/instance/:instanceUniqueId/sales/leads/:view?"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/sales/customers/leads`}
                      />
                    )}
                  />

                  {/* 2) The real customers/leads handler */}
                  <Route
                    path="/instance/:instanceUniqueId/sales/customers/:view?"
                    exact
                    component={InstanceCustomers}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/prospects"
                    exact
                    component={InstanceProspects}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/promostores"
                    exact
                    component={InstancePromoStores}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/promostores/marketplace"
                    exact
                    component={PromoStoreMarketplace}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/promostores/:id/reports/products"
                    exact
                    component={InstancePromoStoreProductReport}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/promostores/:id/:tabtype?"
                    exact
                    component={InstancePromoStoreDetails}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/sales/analytics"
                    exact
                    component={InstanceSalesAnalytics}
                  />
                  {/* Production */}
                  <Route
                    path="/instance/:instanceUniqueId/production/dashboard"
                    exact
                    component={InstanceProductionDashboard}
                  />
                  {/* Purchasing */}
                  <Route
                    path="/instance/:instanceUniqueId/purchasing/dashboard"
                    exact
                    component={InstanceProductionDashboard}
                  />

                  <Route
                    path="/instance/:instanceUniqueId/production/analytics"
                    exact
                    component={InstanceProductionAnalytics}
                  />

                  <Route
                    path="/instance/:instanceUniqueId/production/machines-management"
                    exact
                    component={withProductionStyles(MachineManagements)}
                  />
                  

                  <Route
                    path="/instance/:instanceUniqueId/production/department-management"
                    exact
                    component={withProductionStyles(EliteProductionDepartmentManagement)}
                  />
                
                  <Route
                    path="/instance/:instanceUniqueId/production/materials-management"
                    exact
                    component={withProductionStyles(EliteProductionMaterialsManagement)}
                  />

                  <Route
                    path="/instance/:instanceUniqueId/production/charge-strategies"
                    exact
                    component={withProductionStyles(EliteProductionChargeStrategies)}
                  />
                 
                  {/* <Route
                    path="/instance/:instanceUniqueId/production/production"
                    exact
                    component={EliteProduction}
                  /> */}

                  {/* <Route
                    path="/instance/:instanceUniqueId/production/elite-decorations/:tabType?"
                    exact
                    component={EliteProduction}
                  /> */}
                  <Route
                    path="/instance/:instanceUniqueId/production/production/:tabType?"
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/production/all${match.params.tabType ? `/${match.params.tabType}` : ""}`}
                      />
                    )}
                  />

                  <Route
                    // path="/instance/:instanceUniqueId/production/production/:tabType?"
                    path="/instance/:instanceUniqueId/production/:department/:tabType?"
                    component={withProductionStyles(EliteProduction)}
                  />

                  

                  {/* Finances */}
                  <Route
                    path="/instance/:instanceUniqueId/finance"
                    exact
                    component={InstanceFinancesDashboard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/finance/dashboard"
                    exact
                    component={InstanceFinancesDashboard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/finance/billing"
                    exact
                    component={InstanceBilling}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/finance/invoicing"
                    exact
                    component={InstanceInvoicing}
                  />
                  <Route path="/instance/:instanceUniqueId/invoicing/import" 
                      exact
                      component={ThirdPartyImport}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/shipping/receiving"
                    exact
                    component={InstanceShippingLabels}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/shipping/warehouse-builder"
                    exact
                    component={InstanceWarehouseBuilder}
                  />
                  {/* Reports */}
                  <Route
                    path="/instance/:instanceUniqueId/reports"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        report="dashboard"
                      >
                        <InstanceReportsDashboard />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/dashboard"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        report="dashboard"
                      >
                        <InstanceReportsDashboard />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/commissions"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceCommissionsReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/sales"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        report="sales"
                      >
                        <Redirect to={`/instance/${match.params.instanceUniqueId}/reports/sales-rep`} />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/sales-rep"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        report="sales"
                      >
                        <InstanceSalesReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/documents"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceDocumentReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/product-sold"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceProductSoldReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/supplier"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceSupplierReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/supplier-bill-pipeline"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceSupplierBillPipelineReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/client-invoicing"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceClientInvoicingReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/work-in-progress"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceWorkInProgressReport />
                      </ReportRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/reports/ar-aging"
                    exact
                    render={({ match }) => (
                      <ReportRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                      >
                        <InstanceArAgingReport />
                      </ReportRouteGuard>
                    )}
                  />
                  {/* Operations */}
                  <Route
                    path="/instance/:instanceUniqueId/operations/management"
                    exact
                    component={InstanceOperationsDashboard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/operations/dashboard"
                    exact
                    render={({ match }) => (
                      <Redirect to={`/instance/${match.params.instanceUniqueId}/operations/management`} />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/operations/sales-operations"
                    exact
                    component={InstanceSalesDashboard}
                  />
                  {/* AI Hub */}
                  <Route
                    path="/instance/:instanceUniqueId/ai/:tabType?"
                    exact
                    component={InstanceAIHub}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/dashboard/promoshowcase"
                    exact
                    component={PromoShowcasePage}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/dashboard`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/dashboard"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.VIEW_DASHBOARD]}
                      >
                        <CoreNetworkDashboard />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/work-requests"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.VIEW_REQUEST]}
                      >
                        <CoreNetworkWorkRequestList />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/work-requests/:id"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.VIEW_REQUEST]}
                      >
                        <CoreNetworkWorkRequestDetail />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/talent"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.VIEW_MEMBERS]}
                      >
                        <CoreNetworkTalentList />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/talent/:id"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.VIEW_MEMBER_DETAIL]}
                      >
                        <CoreNetworkTalentDetail />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/matches"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[
                          CORE_NETWORK_PERMISSIONS.GENERATE_MATCHES,
                          CORE_NETWORK_PERMISSIONS.SEND_OFFERS,
                          CORE_NETWORK_PERMISSIONS.ASSIGN_REQUEST,
                        ]}
                        requireMatchesEnabled={true}
                      >
                        <CoreNetworkMatchesPage />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/core-network/settings"
                    exact
                    render={({ match }) => (
                      <CoreNetworkRouteGuard
                        authState={authState}
                        instanceUniqueId={match.params.instanceUniqueId}
                        permissions={[CORE_NETWORK_PERMISSIONS.MANAGE_SETTINGS]}
                      >
                        <CoreNetworkSettings />
                      </CoreNetworkRouteGuard>
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/dashboard`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/overview"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/dashboard`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/work-requests"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/work-requests`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/work-requests/:id"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/work-requests/${match.params.id}`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/talent"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/talent`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/talent/:id"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/talent/${match.params.id}`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/matches"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/matches`}
                      />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/decoration-network/settings"
                    exact
                    render={({ match }) => (
                      <Redirect
                        to={`/instance/${match.params.instanceUniqueId}/core-network/settings`}
                      />
                    )}
                  />
                  {/* Settings */}
                  <Route
                    path="/instance/:instanceUniqueId/settings"
                    exact
                    component={InstanceGlobalSettings}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/settings/users"
                    exact
                    component={InstanceUsers}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/settings/crm"
                    exact
                    render={({ match }) => (
                      <Redirect to={`/instance/${match.params.instanceUniqueId}/settings/global-settings/company-settings/crm`} />
                    )}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/settings/global-settings/:tabType?/:settingType?/:subSettingType?"
                    exact
                    component={InstanceGlobalSettings}
                  />
                  {/* Pre Code */}
                  <Route
                    path="/welcome-to-elite-core"
                    exact
                    component={WelcomeToEliteCore}
                  />
                  <Route path="/new-instance" exact component={CreatePost} />
                  <Route
                    path="/instance/:id/get-started"
                    exact
                    component={InstanceGetStartedWizard}
                  />
                  <Route
                    path="/instance/:instanceUniqueId/add-payment-method"
                    exact
                    component={InstancePaymentFailed}
                  />
                  <Route
                    path="/instance/:instanceUniqueId"
                    exact
                    component={InstanceFeedAndActivity}
                  />
                  <Route
                    path="/instance-manager"
                    exact
                    component={InstanceManager}
                  />
                  <Route path="/invoices" exact component={InvoicesManager} />
                  <Route
                    path="/instance/:instanceUniqueId/website-sync"
                    exact
                    component={InstanceSyncProducts}
                  />
                  <Route path="/registration" exact component={Registration} />
                  <Route path="/customer/:publicSlug" exact component={PublicCustomerPage} />
                  <Route
                    path="/login"
                    exact
                    render={() => {
                      const view = resolveGeneralLoginView({
                        token: getNetworkPortalToken(),
                        isLoading: talentAuthLoading,
                        member: talentMember,
                      });
                      if (view === "talent") return <Redirect to="/talent" />;
                      if (view === "checking") {
                        return (
                          <div
                            role="status"
                            aria-label="Checking Talent Portal session"
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "70vh" }}
                          >
                            <CircularProgress />
                          </div>
                        );
                      }
                      return <Login />;
                    }}
                  />
                  <Route path="/" exact component={Home} />
                  <Route
                    path="/forgot-password"
                    exact
                    component={ForgotPassword}
                  />
                  <Route
                    path="/forgot-password/:token/:email"
                    exact
                    component={ForgotPasswordTokenValid}
                  />
                  <Route path="/profile/:id" exact component={Profile} />
                  <Route path="/profile/:id/ezee-ai" exact component={ProfileEzeeAI} />
                  <Route
                    path="/profile/:id/payment-methods"
                    forceRefresh={true}
                    exact
                    component={PaymentMethods}
                  />
                  <Route
                    path="/profile/:id/change-password"
                    exact
                    component={ChangePassword}
                  />
                  <Route path="*" exact component={PageNotFound} />
                </Switch>

                {shouldShowFooter && (
                  <AppFooter />
                )}
              </Router>
            </AuthContext.Provider>
          </div>
        ) : (
          <></>
        )}
      </NotificationProvider>
    </Fragment>
  );
}

export default App;
